import { useTranslation } from 'react-i18next';
import React from 'react';

import { useCurrentAddressInfo, useSwitch } from '@/hooks';
import style from './index.module.css';
import { AccountModal } from '../AccountModal';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from '@/components';

export const TransferKeyModal = ({ turnOff }: { turnOff(): void }) => {
  const { t } = useTranslation();

  const { address, account: currentAccountInfo } = useCurrentAddressInfo();
  const { on: isContentVisible, turnOn: showContent } = useSwitch(false);
  const steps = [
    {
      handler: turnOff,
      textWidth: 64,
      content: (
        <>
          <div className={style.subTitle}>{t('TransferKeyModal.19ri6mn')}</div>
          <div className={style.qrcodeContainer}>
            <QRCodeSVG
              level="H"
              size={168}
              bgColor="var(--bg-white-color)"
              fgColor="var(--color-black)"
              value={JSON.stringify({
                address,
                accountInfo: currentAccountInfo,
              })}
            />
            {isContentVisible ? null : (
              <div className={style.mask}>
                <Button className={style.showButton} type="primary" onClick={showContent}>
                  {t('TransferKeyModal.77y7pl')}
                </Button>
              </div>
            )}
          </div>
        </>
      ),
    },
  ];

  return (
    <AccountModal
      isLoading={false}
      hideSteps
      headerTitle={t('TransferKeyModal.transfer')}
      turnOff={turnOff}
      steps={steps}
      hideButton
      buttonText={t('TransferKeyModal.next')}
    />
  );
};
